import script from "./reviewProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewProgress.vue?vue&type=script&setup=true&lang=js"

import "./reviewProgress.vue?vue&type=style&index=0&id=5d434a66&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d434a66"]])

export default __exports__